import axios from 'axios';
import api from '../../../utils/api';

export default {
  async fetchAdvertisementBanners({}, type) {
    const { data } = await axios(api.advertisement.fetchAdvertisementBanners(type));
    const results = data.results.sort((a, b) => a.position - b.position);
    return results;
  },
};
